import { call, takeEvery, takeLatest, takeLeading } from "redux-saga/effects";
import { waitForTokenRefreshIfNeeded } from "./SagaCoordinator";

// Wrapper for takeEvery that waits for token refresh
export function* coordinatedTakeEvery(pattern, saga, ...args) {
  yield takeEvery(pattern, function* coordinatedWorker(action) {
    // Wait for token refresh to complete if it's in progress
    yield call(waitForTokenRefreshIfNeeded);
    // Execute the original saga
    yield call(saga, action, ...args);
  });
}

// Wrapper for takeLatest that waits for token refresh
export function* coordinatedTakeLatest(pattern, saga, ...args) {
  yield takeLatest(pattern, function* coordinatedWorker(action) {
    // Wait for token refresh to complete if it's in progress
    yield call(waitForTokenRefreshIfNeeded);
    // Execute the original saga
    yield call(saga, action, ...args);
  });
}

// Wrapper for takeLeading that waits for token refresh
export function* coordinatedTakeLeading(pattern, saga, ...args) {
  yield takeLeading(pattern, function* coordinatedWorker(action) {
    // Wait for token refresh to complete if it's in progress
    yield call(waitForTokenRefreshIfNeeded);
    // Execute the original saga
    yield call(saga, action, ...args);
  });
}

// Generic wrapper for any saga function
export function* coordinatedSaga(sagaFunction, ...args) {
  // Wait for token refresh to complete if it's in progress
  yield call(waitForTokenRefreshIfNeeded);
  // Execute the original saga
  yield call(sagaFunction, ...args);
}

// Helper function to wrap existing saga exports
export function wrapSagaExports(sagaExports) {
  const wrappedExports = {};

  Object.keys(sagaExports).forEach((key) => {
    const originalSaga = sagaExports[key];

    // Create a wrapped version of each saga
    wrappedExports[key] = function* wrappedSaga(...args) {
      yield call(coordinatedSaga, originalSaga, ...args);
    };
  });

  return wrappedExports;
}
